import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { toastNotification } from '../utils/apiFunctions';
import { LocationPaths } from '../utils/common';

const SetupInterceptors = (navigate) => {
  const locationData = useLocation();
  const isUnauthorizedPage = locationData.pathname === LocationPaths.UNAUTHORIZED;

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response) {
        if (error.response.status === 401 && error.response.data === "Failed to authorize with RMM Integrations") {
          return;
        }
        if (!isUnauthorizedPage && (error.response.status === 401 || error.response.status === 403)) {
          toastNotification('Your session has expired. Please log in again.', 'error');
          navigate('/unauthorized', { state: { authorizeUrl: error.response.data } });
        }
        if (error.response.status === 500) {
          toastNotification('Error processing request. Contact Bitdefender support if the issue persists.', 'error');
        }
      }
      return Promise.reject(error);
    }
  );
};

export default SetupInterceptors;